import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";

import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";
import Top from "./Top/Top";
import { useDefaults } from "../context/useSelectFilter";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { defaultBrand } = useDefaults();
  const [defaultBrandSelectionApplied, setDefaultBrandSelectionApplied] =
    useState(false);

  // Flag para controlar aplicação inicial do filtro Ano/Mês
  const [anoMesSelectionApplied, setAnoMesSelectionApplied] = useState(false);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (app && defaultBrand && !defaultBrandSelectionApplied) {
      const qlikFieldNameForBrand = "Marca";
      app
        .field(qlikFieldNameForBrand)
        .selectValues([{ qText: defaultBrand }], false, false)
        .then(() => {
          setDefaultBrandSelectionApplied(true);
        })
        .catch((err) => {
          console.error(
            `Erro ao aplicar seleção padrão '${defaultBrand}' ao campo '${qlikFieldNameForBrand}':`,
            err
          );
        });
    }
  }, [app, defaultBrand, defaultBrandSelectionApplied]);

  useEffect(() => {
    if (!app || anoMesSelectionApplied) return;

    let mounted = true;
    const el = document.createElement("div");
    el.style.display = "none";
    document.body.appendChild(el);

    (async () => {
      try {
        const objectId = "kegDvTz";
        const model = await app.getObject(el, objectId);
        if (!mounted) return;

        const layout = await model.getLayout();
        const childId = layout.qChildList.qItems?.[0]?.qInfo?.qId;
        if (childId) {
          const childModel = await model.getChild(childId); // listbox
          const resp = await childModel.getListObjectData("/qListObjectDef", [
            { qTop: 0, qLeft: 0, qHeight: 1000, qWidth: 1 },
          ]);
          const rows = resp?.[0]?.qMatrix ?? [];

          const firstCell = rows?.[0]?.[0];
          if (firstCell) {
            await childModel.selectListObjectValues(
              "/qListObjectDef",
              [firstCell.qElemNumber],
              false
            );
            console.log(
              "Primeiro valor aplicado no filtro Ano/Mês:",
              firstCell.qText
            );
            setAnoMesSelectionApplied(true);
          }
        }
      } catch (err) {
        console.error("Erro ao aplicar filtro Ano/Mês:", err);
      } finally {
        if (el.parentNode) el.parentNode.removeChild(el);
      }
    })();

    return () => {
      mounted = false;
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [app, anoMesSelectionApplied]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <div className="container-app">
          <LeftSideMenu app={app} config={config} />

          <Switch>
            <Route exact path="/">
              <Redirect to="/overview" />
            </Route>
            <Route
              path="/overview"
              exact
              render={() => <Overview app={app} config={config} />}
            />
            <Route
              path="/top-10"
              exact
              render={() => <Top app={app} config={config} />}
            />
          </Switch>
        </div>
      </HashRouter>
    </div>
  );
}

export default Layout;
